var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVenmo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#venmo_clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.517 0H2.483A2.483 2.483 0 000 2.483v16.034A2.483 2.483 0 002.483 21h16.034A2.483 2.483 0 0021 18.517V2.483A2.483 2.483 0 0018.517 0z",
    fill: "#3396CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.675 4.273c.452.745.654 1.513.654 2.483 0 3.093-2.64 7.11-4.782 9.93H6.654L4.692 4.951l4.286-.407 1.042 8.35c.968-1.58 2.166-4.062 2.166-5.754 0-.926-.159-1.556-.407-2.075l3.896-.792z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "venmo_clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v21H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenmo);
export default __webpack_public_path__ + "static/media/venmo.2d9c3fad2a0f330bf8233009d4f9d73e.svg";
export { ForwardRef as ReactComponent };